import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, ensure } from "sprint-common-web";

import { contentManageRoutes, assetsManageTvSeriesListingRoute } from "../ContentRoutes";
import { TvSeriesContext } from "./details/context/TvSeriesContext";
import { TvSeriesDashboardContext } from "./TvSeriesDashboardProvider";

export const TvSeriesDashboardBreadcrumb: React.FunctionComponent = () => {
    const [items, setItems] = useState<BreadcrumbItem[]>([]);
    const { selectTvSeriesPage, selectedSeason, selectedEpisode, selectCurrentSeason } = useContext(
        TvSeriesDashboardContext
    );
    const { tvSeries, isLoading } = useContext(TvSeriesContext);
    const history = useHistory();

    useEffect(() => {
        setItems(createBreadcrumbItems());
    }, [selectedSeason, selectedEpisode, tvSeries?.title]);

    const createBreadcrumbItems = () => {
        const breadcrumbItems: BreadcrumbItem[] = [
            ...contentManageRoutes.baseRouteNames.map((name: string) => {
                return { key: name, text: name };
            }),
            {
                key: "tv-series",
                text: "Tv Series",
                onClick: goToTvSeriesListing
            },
            {
                key: "",
                text: tvSeries?.title ?? "",
                onClick: goToTvSeriesPage
            }
        ];

        if (selectedSeason) {
            breadcrumbItems.push({
                key: "",
                text: selectedSeason?.name ?? "",
                onClick: goToSeasonPage
            });
        }

        if (selectedEpisode) {
            breadcrumbItems.push({
                key: "",
                text: selectedEpisode?.title ?? ""
            });
        }

        return breadcrumbItems;
    };

    const goToTvSeriesListing = () => {
        history.push(assetsManageTvSeriesListingRoute.path);
    };

    const goToTvSeriesPage = () => {
        selectTvSeriesPage();
    };

    const goToSeasonPage = () => {
        ensure(selectedSeason);

        selectCurrentSeason(selectedSeason.id, selectedSeason.name);
    };

    return <Breadcrumb items={items} isLoading={isLoading} />;
};
